/* eslint-disable */
import React, { Component } from "react";
import Store from "../../content/Store";
import Content from "../../content/Content";
import { connect } from "react-redux";
import styles from "../../assets/css/modules/myprofile/myprofilecommunicationprefs.css";
import PreferenceRequired from '../shared/PreferenceRequired';
import { isGDPRSet } from "../../services/PersonConsent";
import SSOContainer from "../shared/containers/SSOContainer";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import { Paths } from "../../constants/UrlConstants";
import {
  saveCommunicationPreferences,
  loadOptionValues,
  setIsCommValueChanged,

} from "../../actions/policy/policyActions";
import InternalViewButton from "../shared/buttons/InternalViewButton";
import contactPreferenceStyles from "../../assets/css/modules/preference/contact-preferences.css";
import OnBoardingLogout from "../logout/OnboardingLogOut";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";

export const mapStateToProps = ({ policyReducer = {}, preferenceReducer = {}, onboardingReducer = {}, layoutReducer = {} }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const isInternalView =
    policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView;
  return {
    Layout: layoutReducer.layout,
    onboardingFlag: onboardingReducer.isUserOnboarding,
    MembershipNumber: selectedPolicy && selectedPolicy.MembershipNumber,
    Members: selectedPolicy && selectedPolicy.Members,
    PersonConsent: selectedPolicy && selectedPolicy.PersonConsent,
    isInternalView,
    disabled:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView,
    communicationPreferenceKeys: preferenceReducer.communicationPreferencekeys,
    communicationValue: preferenceReducer.communicationValue,
    saveCommunicationPref: preferenceReducer.saveCommunicationPref,
    isElgibleCustomised: preferenceReducer.isElgibleCustomised,
    HasMultiplePolicies:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.HasMultiplePolicies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveCommunicationPreferences: (membershipNumber, updateCommunicationPreferences) =>
      dispatch(saveCommunicationPreferences(membershipNumber, updateCommunicationPreferences)),
    loadOptionValues: (MembershipNumber) => dispatch(loadOptionValues(MembershipNumber)),
    setIsCommValueChanged: (Value) => dispatch(setIsCommValueChanged(Value)),
  };
};

const commsSections = {
  margin: "30px 25px 26px 0",
  paddingLeft: "20px"
};

const radioIndMFA = {
  border: "2px solid #3032c1",
  marginRight:"20px !important",
  marginBottom:"20px !important"
};
const radioInd = {
  border: "2px solid #3032c1"
};
const radioIndHol = {
  border: "2px solid #343C3D"
};

export class CommunicationSupportNeeds extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PersonConsent: props.PersonConsent,
      shownErrors: null,
      preferenceErrors: false,
      preferenceUpdateSuccess: false,
      contactPreferenceUpdateSucceeded: false,
      updateCommunicationPreferences: null,
      shownCommErrors: false,
      commPrefsUpdateSucceeded: false,
      MemberName: null,
      noSelectionError: false,
      IsOnChange: false,
      noChangesError: false,
      isCommPref:true,
      noprefchange:false
    };
    this.onSkipClick = this.onSkipClick.bind(this);
    this.onCommunicationPreferenceSubmit = this.onCommunicationPreferenceSubmit.bind(this);
  }

  onSkipClick(e) {
    e.preventDefault();
    var consent = Object.assign({}, this.props.PersonConsent);
    this.setState({
      PersonConsent: consent
    });

    if (!isGDPRSet(this.props.PersonConsent)) {
      this.props.history.push(Paths.PersonConsent);
    }
    else if (this.props.onboardingFlag && this.state.isCommPref === true) {
      this.props.history.push(Paths.HomeCommunicationPreference);
    }
    else if (this.props.onboardingFlag && this.state.isCommPref === false)
      {
        if (!isGDPRSet(this.props.PersonConsent)) {
          this.props.history.push(Paths.PersonConsent);
        }
        else{
        this.props.history.push(Paths.DocumentPreference);
        }
      }
    else {
      this.props.history.push(Paths.HomeRoot);
    }
  }

  componentDidMount() {
    if (this.props.Members !== null && this.props.Members !== undefined) {
      let loggedInMember = this.props.Members.find((val) => val.IsLoggedInMember === true);
      if (loggedInMember !== null && loggedInMember !== undefined) {
        this.setState({ MemberName: loggedInMember.FullName });
      }
    }
  }

  onCommunicationPreferenceSubmit(e) {
    e.preventDefault();
    if ((this.props.onboardingFlag && this.state.isCommPref === true && this.state.noprefchange === true) || (this.state.isCommPref === true && this.state.noprefchange === true)) {
      this.props.history.push(Paths.HomeCommunicationPreference);
    }
    else if (this.props.onboardingFlag && this.state.isCommPref === false && this.state.noprefchange === true)
    {
      if (!isGDPRSet(this.props.PersonConsent)) {
        this.props.history.push(Paths.PersonConsent);
      }
      else{
      this.props.history.push(Paths.DocumentPreference);
      }
    }
    else if(this.state.noprefchange === true)
      {
        this.props.history.push(Paths.HomeRoot)
      }
  }

  render() {
    return (
      window?.axa?.features?.MFAFeature === "true"?
      <MFASSOContainer mfa={true}>
        <div className={styles.myprofilecommunicationprefs}>
          <div className={styles.pageContainer}>
            <PreferenceRequired isPreferenceRequired
              keys={this.props.communicationPreferenceKeys}
              values={this.props.communicationValue}>
              {this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true ?
                this.props.communicationPreferenceKeys !== null &&
                  this.props.communicationValue !== undefined ? (<div className="row">
                    <div id="communicationPreferenceSection" className="col-12">
                      <div className="com-sup-needs-headline">
                        <h1 className={`axa-headline ${contactPreferenceStyles.titlesMFA}`}><Content
                          name={Store.MyProfileCommunicationNeeds.CommNeedsSection.HomeHeading}
                        /></h1>
                      </div>
                      <Content
                        name={Store.MyProfileCommunicationNeeds.CommNeedsSection.HomeSubheading}
                      />
                      <div>
                        <div className="row justify-content-between align-items-center">
                          <div className="col-12">
                            <React.Fragment>
                              <div>
                                <span className={"form-group label-normal"}>
                                  <label
                                    className={` custom-control custom-radio radio2 align-middle ${styles.commsSectionsYesLabel}`}
                                    htmlFor={"radio" + "Yes"}
                                  >
                                    <div className="col-1">
                                    <input
                                      id={"radio" + "Yes"}
                                      name={"radio"}
                                      type="radio"
                                      // onChange={this.props.onChange}
                                      className="custom-control-input"
                                      value="true"
                                      //defaultChecked={true}
                                    onClick={() => this.setState({ isCommPref: true , noprefchange : true})}
                                    />
                                    <span className={`custom-control-indicator ${styles.radioIndMFA}`} style={radioIndMFA} /></div>
                                    <div className="col-10">
                                    <div className={`${styles.commsSectionYes} ${styles.commsSectionY}`}>
                                      <span className="custom-control-description">
                                        Yes, I have communication support needs.
                                      </span>
                                    </div>
                                    </div>
                                    
                                  </label>
                                  {/* <span className={"form-group label-normal"}></span> */}
                                  <label
                                    className={` custom-control custom-radio radio2 align-middle ${styles.commsSectionsNoLabel}`}
                                    htmlFor={"radio" + "No"}
                                  >
                                    <div className="col-1">
                                    <input
                                      id={"radio" + "No"}
                                      name={"radio"}
                                      type="radio"
                                      onChange={this.props.onChange}
                                      className="custom-control-input"
                                      value="false"
                                      //defaultChecked={this.props.currentValue === false}
                                      onClick={() => this.setState({ isCommPref: false, noprefchange : true})}
                                    />
                                    <span className={`custom-control-indicator ${styles.radioIndMFA}`} style={radioIndMFA}/></div>
                                    <div className="col-10">
                                    <div className={`${styles.commsSectionNo} ${styles.commsSectionN}`}>
                                      <span className="custom-control-description">No, I don't have communication support needs.</span>
                                    </div>
                                    </div>
                                  </label>
                                </span>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>

                      <div id="personconsentMessage">

                        {this.state.noChangesError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content
                              name={
                                Store.MyProfileContactPreferences
                                  .NoChangesMessage
                              }
                            />
                          </div>
                        ) : null}
                        {this.state.noSelectionError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content name={Store.MyProfileContactPreferences.noSelectionCommSupportNeedsError} />
                          </div>
                        ) : null}
                      </div>
                      <form onSubmit={this.onCommunicationPreferenceSubmit}>
                        <div className={"row " + styles.commSectionMFA}>
                          <div className="col-sm-12 text-center">
                            <button
                              label={Store.MyProfileContactPreferences.ContinueButton}
                              className={mfaStyles.buttonStart}
                              type="submit"
                              >{Store.MyProfileContactPreferences.ContinueButton}</button>
                          </div>
                        </div>
                        <div className={contactPreferenceStyles.boxContainer}>
                          <div className={this.props.Layout === 'MOL' ? contactPreferenceStyles.contentContainerMOLMFA : contactPreferenceStyles.contentContainerMFA}>
                            {Store.MyProfileContactPreferences.AccountText}
                          </div>
                          <div className={contactPreferenceStyles.logoutContainer}>
                            <OnBoardingLogout />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>) : (
                  <div
                    className={
                      "alert alert-danger mt-2 " + styles.messages
                    }
                    role="alert"
                  >
                    <Content
                      name={
                        Store.MyProfileCommunicationNeeds.Errors.GetMasterDataFailed
                      }
                    />
                  </div>
                ) : null}
            </PreferenceRequired>
          </div>
        </div>
      </MFASSOContainer>:
      <SSOContainer>
        <div className={styles.myprofilecommunicationprefs}>
          <div className={styles.pageContainer}>
            <PreferenceRequired isPreferenceRequired
              keys={this.props.communicationPreferenceKeys}
              values={this.props.communicationValue}>
              {this.props.isElgibleCustomised === "true" && this.props.personnotfound !== true ?
                this.props.communicationPreferenceKeys !== null &&
                  this.props.communicationValue !== undefined ? (<div className="row">
                    <div id="communicationPreferenceSection" className="col-12">
                      <div className="com-sup-needs-headline">
                        <h1 className={`axa-headline ${contactPreferenceStyles.titles}`}><Content
                          name={Store.MyProfileCommunicationNeeds.CommNeedsSection.HomeHeading}
                        /></h1>
                      </div>
                      <Content
                        name={Store.MyProfileCommunicationNeeds.CommNeedsSection.HomeSubheading}
                      />
                      <div>
                        <div className="row justify-content-between align-items-center">
                          <div className="col-12">
                            <React.Fragment>
                              <div>
                                <span className={"form-group label-normal"}>
                                  <label style={{ margin: "30px 25px 0 0", paddingBottom: "40px",paddingLeft: "20px" }}
                                    className=" bottom-line-addition custom-control custom-radio radio2 align-middle"
                                    htmlFor={"radio" + "Yes"}
                                  >

                                    <div className={styles.commsSectionY}>
                                      <span className="custom-control-description">
                                        Yes, I have communication support needs
                                      </span>
                                    </div>
                                    <input
                                      id={"radio" + "Yes"}
                                      name={"radio"}
                                      type="radio"
                                      // onChange={this.props.onChange}
                                      className="custom-control-input"
                                      value="true"
                                      //defaultChecked={true}
                                    onClick={() => this.setState({ isCommPref: true , noprefchange : true})}
                                    />
                                    <span className="custom-control-indicator mr-0 ml-3" style={this.props.Layout === "MOL" ? radioInd : radioIndHol}  />
                                  </label>
                                  {/* <span className={"form-group label-normal"}></span> */}
                                  <label style={commsSections}
                                    className="custom-control custom-radio radio2 align-middle"
                                    htmlFor={"radio" + "No"}
                                  >
                                    <input
                                      id={"radio" + "No"}
                                      name={"radio"}
                                      type="radio"
                                      onChange={this.props.onChange}
                                      className="custom-control-input"
                                      value="false"
                                      //defaultChecked={this.props.currentValue === false}
                                      onClick={() => this.setState({ isCommPref: false, noprefchange : true})}
                                    />
                                    <div className={styles.commsSectionN}>
                                      <span className="custom-control-description">No, I don't have communication support needs</span>
                                    </div><span className="custom-control-indicator mr-0 ml-2" style={this.props.Layout === "MOL" ? radioInd : radioIndHol} />
                                  </label>
                                </span>
                              </div>
                            </React.Fragment>
                          </div>
                        </div>
                      </div>

                      <div id="personconsentMessage">

                        {this.state.noChangesError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content
                              name={
                                Store.MyProfileContactPreferences
                                  .NoChangesMessage
                              }
                            />
                          </div>
                        ) : null}
                        {this.state.noSelectionError ? (
                          <div
                            className={
                              "alert alert-danger mt-2 " + styles.messages
                            }
                            role="alert"
                          >
                            <Content name={Store.MyProfileContactPreferences.noSelectionCommSupportNeedsError} />
                          </div>
                        ) : null}
                      </div>
                      <form onSubmit={this.onCommunicationPreferenceSubmit}>
                        <div className={"row " + styles.commSection}>
                          <div className="col-sm-12 text-center">
                            <InternalViewButton
                              id="btn-contactPreference"
                              type="submit"
                              className="form-control btn btn-submit"
                              //disabled={this.props.disabled}
                              label={
                                Store.MyProfileContactPreferences.ContinueButton
                              }
                              btntype="homeButton"
                            />
                          </div>
                        </div>
                        <div className={contactPreferenceStyles.boxContainer}>
                          <div className={this.props.Layout === 'MOL' ? contactPreferenceStyles.contentContainerMOL : contactPreferenceStyles.contentContainer}>
                            {Store.MyProfileContactPreferences.AccountText}
                          </div>
                          <div className={contactPreferenceStyles.logoutContainer}>
                            <OnBoardingLogout />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>) : (
                  <div
                    className={
                      "alert alert-danger mt-2 " + styles.messages
                    }
                    role="alert"
                  >
                    <Content
                      name={
                        Store.MyProfileCommunicationNeeds.Errors.GetMasterDataFailed
                      }
                    />
                  </div>
                ) : null}
            </PreferenceRequired>
          </div>
        </div>
      </SSOContainer>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunicationSupportNeeds);